import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import {
  institutionSetActualDataReducerType,
  institutionSetInstitutionsForSearchReducerType,
  institutionSetInstitutionsGroupsReducerType,
  institutionSetIsLoadingReducerType,
  institutionSetNotificationsReducerType,
  institutionSetIpAddressReducerType,
  institutionResetStateReducerType,
} from './InstitutionConstants';

export const initialState = Map({
  isLoading: false,
  notifications: null,
  ipAddress: null,
  isAnonymousUser: false,
  institutionsForSearch: [],
  institutionsGroups: [],
  actualData: {
    group: '',
    institution: '',
    currentInstitutions: [],
    callbackUrl: '',
    rememberChoice: true,
  },
});

const spec = {
  [institutionSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [institutionSetIpAddressReducerType]: (state, action) => {
    const { ipAddress } = action.payload;
    return state.set('ipAddress', ipAddress);
  },
  [institutionSetNotificationsReducerType]: (state, action) => {
    const { notifications } = action.payload;
    return state.set('notifications', notifications);
  },
  [institutionSetInstitutionsForSearchReducerType]: (state, action) => {
    const currentValue = state.get('institutionsForSearch');
    const { institutionsForSearch } = action.payload;
    return state.set('institutionsForSearch', currentValue.concat(institutionsForSearch));
  },
  [institutionSetInstitutionsGroupsReducerType]: (state, action) => {
    const currentValue = state.get('institutionsGroups');
    const { institutionsGroups } = action.payload;
    return state.set('institutionsGroups', currentValue.concat(institutionsGroups));
  },
  [institutionSetActualDataReducerType]: (state, action) => {
    const { actualData } = action.payload;
    return state.set('actualData', actualData);
  },
  [institutionResetStateReducerType]: () => initialState,
};

export default createReducerBySpec(spec, initialState);
